import { useEffect } from "react"
import { useLocation } from "react-router-dom"
import observabilityService from "../../services/observability_service"

const PerformanceTracker = () => {
    const location = useLocation()

    useEffect(() => {
        // Marcamos o início da navegação
        const startTime = performance.now()

        // Como o React renderiza de forma assíncrona, usamos um pequeno delay 
        // ou requestAnimationFrame para medir quando a página "estabilizou"
        const handleMeasure = () => {
            const endTime = performance.now()
            const duration = endTime - startTime

            // Registramos apenas se for uma mudança de rota real
            observabilityService.logPerformance("route_change_duration", duration, {
                path: location.pathname,
                timestamp: new Date().toISOString()
            })
        }

        // Tenta medir após o próximo frame de renderização
        requestAnimationFrame(() => {
            setTimeout(handleMeasure, 100)
        })

    }, [location.pathname])

    return null
}

export default PerformanceTracker
